import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const AtmIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M51.9473 143.518H108.053C110.879 143.518 113.14 141.246 113.14 138.471V43.6216C113.14 40.818 110.85 38.5751 108.053 38.5751H51.9473C49.121 38.5751 46.8604 40.8475 46.8604 43.6216V138.442C46.8604 141.246 49.1509 143.489 51.9473 143.489V143.518Z"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M66.1932 78.1069C65.0251 78.4022 64.207 79.4534 64.207 80.6584V83.3825C64.207 84.5954 65.0356 85.6514 66.2137 85.9393L77.9052 88.7982V93.2948L66.2137 96.1537C65.0356 96.4416 64.207 97.4976 64.207 98.7105V101.435C64.207 102.64 65.0251 103.691 66.1932 103.986L77.9052 106.95V110.009C77.9052 111.165 78.8427 112.103 79.9992 112.103C81.1558 112.103 82.0933 111.165 82.0933 110.009V108.027L92.5135 110.664C94.1769 111.085 95.7914 109.828 95.7914 108.113V107.144C95.7914 105.909 94.9323 104.84 93.7263 104.574L82.0933 102.008V97.4408L93.7885 94.5608C94.965 94.2713 95.7914 93.2164 95.7914 92.0051V90.0879C95.7914 88.8767 94.965 87.8217 93.7885 87.5322L82.0933 84.6522V80.1083L93.7306 77.5215C94.9344 77.2541 95.7914 76.186 95.7914 74.9527V73.9804C95.7914 72.2648 94.1769 71.0078 92.5135 71.4289L82.0933 74.0657V72.0843C82.0933 70.9278 81.1558 69.9902 79.9992 69.9902C78.8427 69.9902 77.9052 70.9278 77.9052 72.0843V75.1432L66.1932 78.1069ZM77.9052 81.0221V83.6215L72.9754 82.404V82.1229L77.9052 81.0221ZM82.0933 89.8284L86.6304 90.9296V91.1634L82.0933 92.2646V89.8284ZM77.9052 98.4715V101.071L72.9322 99.9702V99.6891L77.9052 98.4715Z"
                fill={color}
                stroke={color}
                strokeWidth="0.2"
            />
            <path
                d="M31.7982 55.1451H23.9071C22.6656 55.1451 21.4792 54.6375 20.5962 53.735C19.7133 52.8325 19.2166 51.592 19.2443 50.3227V21.3043C19.2443 20.0352 19.7409 18.7944 20.6238 17.892C21.5067 16.9895 22.6931 16.4819 23.9348 16.4819H136.093C138.686 16.4819 140.783 18.6534 140.756 21.3043V50.3227C140.756 51.6201 140.259 52.8325 139.376 53.735C138.493 54.6375 137.307 55.1451 136.065 55.1451H128.174"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M80.0008 60.6685C83.0513 60.6685 85.5242 58.1956 85.5242 55.1452C85.5242 52.0948 83.0513 49.6219 80.0008 49.6219C76.9504 49.6219 74.4775 52.0948 74.4775 55.1452C74.4775 58.1956 76.9504 60.6685 80.0008 60.6685Z"
                fill={color}
            />
            <path
                d="M80.0008 132.471C83.0513 132.471 85.5242 129.999 85.5242 126.948C85.5242 123.898 83.0513 121.425 80.0008 121.425C76.9504 121.425 74.4775 123.898 74.4775 126.948C74.4775 129.999 76.9504 132.471 80.0008 132.471Z"
                fill={color}
            />
        </svg>
    );
};
